// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Le lieu d’exécution du contrat est décrit par :\n\n- Le nom (enseigne ou à défaut, raison sociale) et le numéro SIRET de l’entreprise.\n- La description de l’employeur et/ou du service où s’exécutera le contrat.\n- La tranche effectif de l’entreprise, en nombre de salariés.\n- Le site web de l’entreprise.\n"
export default markdown
